var gradeArray = [
  "问题员工",
  "差距员工",
  "带发展者",
  "基本胜任",
  "中坚力量",
  "潜力之星",
  "熟练员工",
  "绩效之星",
  "超级明星",
];
const colorArray = [
  "#FFEEE9",
  "#FFF5E5",
  "#E9F5FE",
  "#FFF5E5",
  "#E9F5FE",
  "#E9F9FB",
  "#E9F5FE",
  "#E9F9FB",
  "#EDF7EE",
];

const descs = ["xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"];

var xAxisScales = 3,
  yAxisScales = 3;
var mockData = {
  xAxisInfo: {
    // x轴数据
    name: "能力",
    valueType: {
      type: "grade", // percent grade  score
      lock: false,
    },
    divideScale: {
      values: ["较差", "中等", "优秀"],
      lock: true,
      range: "left",
    },
  },
  yAxisInfo: {
    // y轴数据
    name: "绩效",
    valueType: {
      type: "grade",
      lock: false,
    },
    divideScale: {
      values: ["C", "B", "S/A"],
      lock: false,
      range: "false",
    },
  },
  gridData: {
    // 宫格的所有数据
    anchor: {
      position: "right", // left  right
      backColor: "#FFE5E1",
      color: "#333",
    },
    colorScheme: "#156476",
    xAxisScales: xAxisScales,
    yAxisScales: yAxisScales,
    gridBlocks: Array.from(
      { length: xAxisScales * yAxisScales },
      (_, index) => ({
        number: `${index + 1}`,
        name: {
          text: gradeArray[index],
          fontColor: "#666",
        },
        desc: {
          text: descs[0],
          fontColor: "#999999",
        },
        backColor: colorArray[index],
      })
    ),
  },
  personInfo: {
    // 需要高亮的宫格
    number: "9",
  },
};

export { mockData };
